var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.svg = {
	init: function () {
		$('img[src*=".svg"]').each(function() {
			var $img = $(this);
			$.get($img.attr('src'), function(data) {
				var $svg = $(data).find('svg').removeAttr('xmlns:a');
				$.each($img.prop('attributes'), function() {
					$svg.attr(this.name, this.value);
				});
				$img.replaceWith($svg);
			}, 'xml');
		});
	}
};

site.listContent = {
	init: function () {
		site.maxHeight.init('td .content .wrap');

		$('.hasContent', '#extras .category').click( function (e) {
			if (!$(e.target).is('a')) {
				e.preventDefault();
				var $content = $(this).find('.content');

				$(this).toggleClass('open');
				$content.toggleClass('open');
			}
		});
	}
};

site.navigation = {
	init: function () {
		var $body = $('body');
		if ($body.width() < 768) {
			site.maxHeight.init('.navigationMenu .menu.mmLevel3');
			$('.navigationMenu .mmLevel2 .level2').click( function (e) {
				if (!$(e.target).is('a') && $(e.target).find('> ul').length > 0) {
					e.preventDefault();
					$(this).toggleClass('open');
				}
			});
		}
	},
	animate: function () {
		var $menuItems = $('#navigation .navigationMenu .menu li');

		$menuItems.waypoint(function () {
			$(this.element).css("opacity","1");
		},{ offset: '100%' });
	}
};

site.frontMobileMenu = {
	init: function () {
		var $qnForm = $('#qn').find('.qn.formbuilder').clone();
		$('#banner .mobileQn').append($qnForm);
		var $mainmenu = $('nav#mainmenu').find('.mmLevel1').clone();
		$('#banner').append($mainmenu);

		site.maxHeight.init('#banner .mmLevel1 .mmLevel2');
		$('#banner .mmLevel1 .level1.goto').click( function (e) {
			console.log($(e.target));
			if (!$(e.target).is('a')) {
				e.preventDefault();
				$(this).toggleClass('open');
			}
		});
	}
};

site.footerEnLink = {
	init:function () {
		$('footer .box.themeColor').each(function() {
			if ($('a', $(this)).length === 1) {
				$(this).addClass('singleLink');
			}
		});
	}
};

site.frontpage = {
	init: function() {
		if ($('.item', '#owl-front').length > 1) {
			site.owl.init('#owl-front .siteWrap', {
				loop: true,
				dots: true,
				nav: false,
				mouseDrag:false,
				items: 1,
				navText: ["", ""],
				stopOnHover: true,
				autoplay: true,
				autoplayTimeout: 6000,
				autoplaySpeed:500,
				smartSpeed:500,
				animateOut: 'fadeOut',
				animateIn: 'fadeIn'
			});
		}

		$('main .box.themeColor').each(function() {
			if ($('a', $(this)).length === 1) {
				$(this).addClass('singleLink');
			}
		});
		site.frontMobileMenu.init();
		site.frontpage.newsCarousel();
		$(window).resize(function() {
			site.frontpage.newsCarousel();
		});

		site.frontpage.animation();
	},

	hasCarousel: false,
	newsCarousel: function() {
		var $body = $('body');
		if ($body.width() < 768) {

			if (!site.frontpage.hasCarousel) {
				site.owl.init('.box_newsheadlines:not(.recall) .itemsWrap', {
					loop: true,
					dots:false,
					mouseDrag: true,
					touchDrag: true,
					margin: 20,
					nav: true,
					navText: ["<i class=\"fas fa-arrow-alt-circle-left\"></i>", "<div class=\"arrow\"><i class=\"fas fa-arrow-alt-circle-right\"></i></div>"],
					stopOnHover: true,
					navSpeed:1000,
					items: 1
				});
				site.frontpage.hasCarousel = true;
			}
		}
		else {
			if (site.frontpage.hasCarousel) {
				$('.box_newsheadlines .items').owlCarousel('destroy').removeClass('owl-carousel');
				site.frontpage.hasCarousel = false;
			}
		}
	},
	animation: function () {
		var $bannerImg = $('.frontpage #owl-front .owl-item.active .imageWrap .wrap');
		var $bannerTxt = $('.frontpage #owl-front .owl-item.active .textWrap .text');
		var $frontBoxes = $('.frontpage #main .box_tiny .wrap');
		var $frontBoxesNewsCatRecall = $('.frontpage #main .box_newsheadlines.recall .wrap');
		var $bannerTopTxt = $('.frontpage #banner .box_tiny.first .boxText');

		$bannerImg.css('opacity', 0).addClass('animated');
		$bannerTxt.css('opacity', 0).addClass('animated');
		$bannerTopTxt.css('opacity', 0).addClass('animated');
		$frontBoxes.css('opacity', 0).addClass('animated');
		$frontBoxesNewsCatRecall.css('opacity', 0).addClass('animated');

		$bannerImg.waypoint(function () {
			$(this.element).removeAttr('style');
			$(this.element).addClass("moveInFromRight");
		},{ offset: '100%' });

		$bannerTxt.waypoint(function () {
			$(this.element).removeAttr('style');
			$(this.element).addClass("moveInFromLeft");
		},{ offset: '100%' });

		$bannerTopTxt.waypoint(function () {
			$(this.element).removeAttr('style');
			$(this.element).addClass("moveInFromLeft");
		},{ offset: '100%' });

		$frontBoxes.waypoint(function () {
			$(this.element).removeAttr('style');
			$(this.element).addClass("fadeInUp");
		},{ offset: '100%' });

		$frontBoxesNewsCatRecall.waypoint(function () {
			$(this.element).removeAttr('style');
			$(this.element).addClass("fadeInUp");
		},{ offset: '100%' });

	}
};

site.searchBox = {
	animate: function () {
		var $searchTxt = $('#searchForm .elm_text label');

		$searchTxt.waypoint(function () {
			$(this.element).addClass("fadeIn");
		},{ offset: '100%' });
	}
};

site.bannerAnimation = {
	animate: function () {
		var $customBanner = $('#banner #custom-banner .innerWrap .wrap');

		if($customBanner) {
			$customBanner.css('opacity', 0).addClass('animated');

			$customBanner.waypoint(function () {
				$(this.element).removeAttr('style');
				$(this.element).addClass("moveInFromRight");
			},{ offset: '100%' });
		}
	}
};

site.autoCompleteSearch = {
	init: function () {
		var $qWidth = $('#q').outerWidth();
		$('.ui-autocomplete').css('max-width', $qWidth);
		$(window).on('resize', function() {
			var $qWidth = $('#q').outerWidth();
			$('.ui-autocomplete').css('max-width', $qWidth);
		})
	}
};

site.mobileSearch = {
	appendSearch: function() {
		var $html = $('<div id="searchBoxMobile" role="search"></div>'),
			$mSearchBox = $('#searchForm').clone().removeAttr('id');
		$html.append($mSearchBox);
		$header = $('header');
		$html.appendTo($header);

		$('[id]', $mSearchBox).each(function() {
			var $this = $(this),
				$id = $this.attr('id'),
				$newId = 'm'+$id.substr(0,1).toUpperCase()+$id.substr(1),
				$label = $('label[for="'+$id+'"]', $mSearchBox);

			if ($label.length > 0) {
				$label.attr('for', $newId);
			}
			$this.attr('id', $newId);
		});
	}
};

site.page = {
	init: function () {
		const toggle = $('#menuToggleCheckbox');
		if (toggle) {
			toggle.click(function(e) {
				e.stopPropagation();
				if (!$('body').hasClass('menuToggle-open')) {
					$('body').addClass('menuToggle-open');
				}
				else {
					$('body').removeClass('menuToggle-open');
				}
			});
			$('body').click(function() {
				if ($('body').hasClass('menuToggle-open')) {
					$('body').removeClass('menuToggle-open');
				}
			});

			const pathname = window.location.pathname;
			const pageId = pathname.substring(pathname.lastIndexOf('/') + 1, pathname.length)
			if (pageId) {
				const selected = $('#'+pageId);
				if (selected) {
					selected.addClass('selected');
				}
			}
		}
	}
};

site.newsSidebar = {
	init: function () {
		var sidebar = $('aside .box_pagecontent').find('a');
		$.each(sidebar, function (i, value) {
			if(value.href == window.location.href) {
				value.className += "selected";
			}
		});
	}
};

site.datafilter = {
	options: {
		updateQueryOnType: true,
		addQueryToInput: true
	}
};

site.accordion = {
	getOpenOffset: function() {
		return 9;
	},
	shouldAddHashes: true,
	shouldUpdateHash: true,
	shouldFollowHash: true,
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.svg.init();
	site.mobileSearch.appendSearch();
	site.headSearch.init();
	site.labelFocus.init();
	site.listContent.init();
	site.navigation.init();
	site.bannerAnimation.animate();
	site.autoCompleteSearch.init();
	site.navigation.animate();
	site.searchBox.animate();
	site.footerEnLink.init();
	site.page.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}
	if ($body.is('.newsOverview') || $body.is('.newsView')) {
		site.newsSidebar.init();
	}

	if ($('html')[0].lang === 'is') {
		$('#mMenu #qn #divisions .menu .en span').text('English');
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', 'main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', 'main').wrap('<div class="table-responsive"></div>');
	}

	$('.shareThis').click(function(e) {
		e.preventDefault();
		var width = ($(this).data('width') !== undefined) ? $(this).data('width') : 550;
		var height = ($(this).data('height') !== undefined) ? $(this).data('height') : 500;
		popCenter($(this).attr('href'), 'lalli', width, height);
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});

function popCenter(url, title, w, h) {
	var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
	var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

	var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	var left = ((width / 2) - (w / 2)) + dualScreenLeft;
	var top = ((height / 2) - (h / 2)) + dualScreenTop;
	var newWindow = window.open(url, title, 'scrollbars=0, toolbar=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}
